// src/row.tsx
import * as React from "react";
import { jsx } from "react/jsx-runtime";
var Row = React.forwardRef(
  ({ children, style, ...props }, forwardedRef) => {
    return /* @__PURE__ */ jsx(
      "table",
      {
        align: "center",
        width: "100%",
        ...props,
        ref: forwardedRef,
        "data-id": "react-email-row",
        style,
        role: "presentation",
        cellSpacing: "0",
        cellPadding: "0",
        border: 0,
        children: /* @__PURE__ */ jsx("tbody", { style: { width: "100%" }, children: /* @__PURE__ */ jsx("tr", { style: { width: "100%" }, children }) })
      }
    );
  }
);
Row.displayName = "Row";
export {
  Row
};
